(() => {
  const THEMES = {
    "race-track": {
      name: "Race Track",
      heroKicker: "赛道倾向的高功率产品表达",
      heroPill: "Race Performance",
      heroTitle: "Power-biased layout for riders who buy on throttle response.",
      heroCopy: "主视觉强调功率、极速与扭矩曲线，适合竞速型产品线和性能新品发布。",
      stats: [
        { label: "Peak RPM", value: "2200" },
        { label: "Boost Power", value: "9000 W" },
        { label: "0-50 km/h", value: "3.4 s" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/race_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#130806",
        "--bg-1": "#3d1010",
        "--panel": "rgba(35, 12, 9, 0.74)",
        "--text": "#fff7ef",
        "--muted": "#d8b7a2",
        "--accent": "#ff7a29",
        "--accent-2": "#e6393f",
        "--chip": "rgba(255, 122, 41, 0.18)",
        "--border": "rgba(255, 197, 147, 0.24)",
        "--glow": "0 0 0 1px rgba(255, 122, 41, 0.22), 0 1.25rem 3rem rgba(36, 11, 11, 0.45)",
        "--surface": "linear-gradient(150deg, rgba(41, 17, 14, 0.8), rgba(24, 11, 10, 0.94))",
        "--hero-orb": "radial-gradient(circle at 20% 25%, rgba(255, 122, 41, 0.67), rgba(255, 122, 41, 0) 46%), radial-gradient(circle at 80% 75%, rgba(230, 57, 63, 0.6), rgba(230, 57, 63, 0) 44%), linear-gradient(130deg, rgba(20, 8, 8, 0.9), rgba(52, 16, 16, 0.9))",
        "--body-grad": "radial-gradient(circle at 15% 10%, #461a13 0%, #1a0d0b 38%, #090506 100%)"
      }
    },
    "off-road-trail": {
      name: "Off-Road Trail",
      heroKicker: "通过性、悬挂和姿态控制优先",
      heroPill: "Trail Conquer Set",
      heroTitle: "Terrain-first layout for riders who treat roads as optional.",
      heroCopy: "更强调悬挂、胎宽、爬坡能力与姿态控制，适合越野系列主站视觉。",
      stats: [
        { label: "Climb Angle", value: "40°" },
        { label: "Torque", value: "260 N·m" },
        { label: "Suspension", value: "130 mm" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/extreme_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#07110b",
        "--bg-1": "#103526",
        "--panel": "rgba(10, 28, 19, 0.75)",
        "--text": "#effff3",
        "--muted": "#a8ccb6",
        "--accent": "#41db8b",
        "--accent-2": "#18a84f",
        "--chip": "rgba(65, 219, 139, 0.16)",
        "--border": "rgba(136, 214, 168, 0.26)",
        "--glow": "0 0 0 1px rgba(65, 219, 139, 0.22), 0 1.25rem 3rem rgba(7, 19, 12, 0.5)",
        "--surface": "linear-gradient(148deg, rgba(13, 35, 21, 0.82), rgba(8, 19, 13, 0.94))",
        "--hero-orb": "radial-gradient(circle at 20% 22%, rgba(65, 219, 139, 0.6), rgba(65, 219, 139, 0) 47%), radial-gradient(circle at 78% 74%, rgba(24, 168, 79, 0.58), rgba(24, 168, 79, 0) 44%), linear-gradient(130deg, rgba(7, 18, 12, 0.9), rgba(15, 44, 32, 0.9))",
        "--body-grad": "radial-gradient(circle at 12% 8%, #1c5034 0%, #0c1d14 40%, #040907 100%)"
      }
    },
    "long-distance-cruise": {
      name: "Long-Distance Cruise",
      heroKicker: "长续航与舒适巡航的首页语言",
      heroPill: "Cruise Priority",
      heroTitle: "Range-first homepage for riders who count real kilometers.",
      heroCopy: "信息传达重心放在电池容量、真实续航和巡航舒适性，适合通勤+远程场景。",
      stats: [
        { label: "Eco Range", value: "190 km" },
        { label: "Battery", value: "3000 Wh" },
        { label: "Wh / km", value: "15.7" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/x-way_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#07111a",
        "--bg-1": "#112943",
        "--panel": "rgba(11, 25, 42, 0.76)",
        "--text": "#eff8ff",
        "--muted": "#9fc1db",
        "--accent": "#4fb2ff",
        "--accent-2": "#2d78cb",
        "--chip": "rgba(79, 178, 255, 0.16)",
        "--border": "rgba(144, 193, 234, 0.26)",
        "--glow": "0 0 0 1px rgba(79, 178, 255, 0.2), 0 1.125rem 2.875rem rgba(10, 23, 37, 0.48)",
        "--surface": "linear-gradient(148deg, rgba(14, 31, 53, 0.82), rgba(7, 17, 30, 0.95))",
        "--hero-orb": "radial-gradient(circle at 21% 22%, rgba(79, 178, 255, 0.62), rgba(79, 178, 255, 0) 47%), radial-gradient(circle at 80% 78%, rgba(45, 120, 203, 0.56), rgba(45, 120, 203, 0) 45%), linear-gradient(130deg, rgba(6, 15, 29, 0.9), rgba(18, 42, 71, 0.9))",
        "--body-grad": "radial-gradient(circle at 10% 12%, #1d446f 0%, #0c1d31 42%, #04080f 100%)"
      }
    },
    "geek-diagnostic": {
      name: "Geek Diagnostic",
      heroKicker: "更技术化、更像实时仪表而不是传统商城",
      heroPill: "System Diagnostics",
      heroTitle: "HUD-style presentation for technical riders who read data first.",
      heroCopy: "适合强调 App 连接、固件更新、电控诊断能力的技术型品牌叙事。",
      stats: [
        { label: "Sensor Set", value: "9-axis IMU" },
        { label: "Data Refresh", value: "100 Hz" },
        { label: "Fault Alert", value: "< 0.2 s" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/falcon_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#050911",
        "--bg-1": "#142036",
        "--panel": "rgba(9, 17, 34, 0.78)",
        "--text": "#eaf4ff",
        "--muted": "#93aacc",
        "--accent": "#4f95ff",
        "--accent-2": "#31e89f",
        "--chip": "rgba(79, 149, 255, 0.17)",
        "--border": "rgba(135, 170, 226, 0.24)",
        "--glow": "0 0 0 1px rgba(79, 149, 255, 0.24), 0 1.25rem 3rem rgba(6, 12, 24, 0.54)",
        "--surface": "linear-gradient(145deg, rgba(11, 20, 39, 0.85), rgba(7, 13, 24, 0.95))",
        "--hero-orb": "radial-gradient(circle at 20% 24%, rgba(79, 149, 255, 0.62), rgba(79, 149, 255, 0) 46%), radial-gradient(circle at 78% 76%, rgba(49, 232, 159, 0.56), rgba(49, 232, 159, 0) 44%), linear-gradient(130deg, rgba(5, 9, 17, 0.92), rgba(18, 34, 58, 0.9))",
        "--body-grad": "radial-gradient(circle at 14% 10%, #223459 0%, #0c1526 40%, #03050a 100%)"
      }
    },
    "cyber-night-ride": {
      name: "Cyber Night Ride",
      heroKicker: "紫色夜骑旗舰提案，强调品牌记忆和城市速度感",
      heroPill: "Purple Night Ride",
      heroTitle: "Own the night with a sharper purple performance signature.",
      heroCopy: "用紫色主导的夜骑语言强化 Begode 的科技辨识度，把速度、灯效和稳定控制统一成更鲜明的官网首页记忆点。",
      stats: [
        { label: "Top Speed", value: "85 km/h" },
        { label: "Peak Power", value: "7500 W" },
        { label: "Range", value: "150 km" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/falcon_pro_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#090611",
        "--bg-1": "#1c1330",
        "--panel": "rgba(20, 13, 37, 0.76)",
        "--text": "#f8f5ff",
        "--muted": "#b2a5d1",
        "--accent": "#b45cff",
        "--accent-2": "#7b61ff",
        "--chip": "rgba(180, 92, 255, 0.18)",
        "--border": "rgba(178, 165, 209, 0.22)",
        "--glow": "0 0 0 1px rgba(180, 92, 255, 0.3), 0 1.25rem 3rem rgba(25, 12, 44, 0.62)",
        "--surface": "linear-gradient(145deg, rgba(24, 16, 44, 0.8), rgba(11, 8, 24, 0.94))",
        "--hero-orb": "radial-gradient(circle at 22% 20%, rgba(180, 92, 255, 0.75), rgba(180, 92, 255, 0) 48%), radial-gradient(circle at 74% 72%, rgba(123, 97, 255, 0.62), rgba(123, 97, 255, 0) 47%), linear-gradient(130deg, rgba(10, 7, 20, 0.94), rgba(28, 19, 48, 0.94))",
        "--body-grad": "radial-gradient(circle at 10% 10%, #261445 0%, #0a0712 42%, #040406 100%)"
      }
    },
    "minimal-light": {
      name: "Minimal Light",
      heroKicker: "高端留白导向的产品陈列风格",
      heroPill: "Minimal Product Focus",
      heroTitle: "Clean catalog styling with premium simplicity and strict hierarchy.",
      heroCopy: "突出产品图与关键参数，减少视觉噪音，适合品牌升级期的简约表达。",
      stats: [
        { label: "Weight", value: "33 kg" },
        { label: "Charge Time", value: "4.5 h" },
        { label: "IP Rating", value: "IPX6" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/x-max_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#f3f5f8",
        "--bg-1": "#e6ebf2",
        "--panel": "rgba(255, 255, 255, 0.85)",
        "--text": "#0f1115",
        "--muted": "#4d5460",
        "--accent": "#1f2430",
        "--accent-2": "#4a5366",
        "--chip": "rgba(31, 36, 48, 0.08)",
        "--border": "rgba(17, 24, 39, 0.14)",
        "--glow": "0 0 0 1px rgba(24, 30, 45, 0.14), 0 1rem 2.5rem rgba(40, 46, 60, 0.12)",
        "--surface": "linear-gradient(145deg, rgba(255, 255, 255, 0.94), rgba(241, 245, 250, 0.96))",
        "--hero-orb": "radial-gradient(circle at 24% 21%, rgba(129, 141, 166, 0.32), rgba(129, 141, 166, 0) 47%), radial-gradient(circle at 72% 76%, rgba(82, 92, 112, 0.25), rgba(82, 92, 112, 0) 45%), linear-gradient(130deg, rgba(236, 241, 247, 0.95), rgba(219, 227, 238, 0.95))",
        "--body-grad": "radial-gradient(circle at 14% 10%, #ffffff 0%, #eef2f7 42%, #dde5ee 100%)"
      }
    },
    "minimal-dark": {
      name: "Minimal Dark",
      heroKicker: "黑白秩序感更强的旗舰陈列方式",
      heroPill: "Black Label Series",
      heroTitle: "Minimal black showcase with a more deliberate flagship hierarchy.",
      heroCopy: "全站黑白秩序与强对比文字，适合打造沉浸式旗舰机型首页。",
      stats: [
        { label: "Body Material", value: "Al-Mg" },
        { label: "Controller", value: "FOC v3" },
        { label: "Thermal Limit", value: "86°C" }
      ],
      heroImage: "https://cdn.shopify.com/s/files/1/0747/7231/6404/files/blitz_700_857.webp?v=1753079299",
      vars: {
        "--bg-0": "#090909",
        "--bg-1": "#151515",
        "--panel": "rgba(20, 20, 20, 0.84)",
        "--text": "#f2f2f2",
        "--muted": "#a8a8ae",
        "--accent": "#f5f5f5",
        "--accent-2": "#8d8d95",
        "--chip": "rgba(245, 245, 245, 0.08)",
        "--border": "rgba(255, 255, 255, 0.18)",
        "--glow": "0 0 0 1px rgba(255, 255, 255, 0.12), 0 1.125rem 2.8125rem rgba(0, 0, 0, 0.52)",
        "--surface": "linear-gradient(145deg, rgba(24, 24, 24, 0.93), rgba(14, 14, 14, 0.95))",
        "--hero-orb": "radial-gradient(circle at 26% 20%, rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0) 48%), radial-gradient(circle at 70% 72%, rgba(173, 173, 182, 0.22), rgba(173, 173, 182, 0) 47%), linear-gradient(130deg, rgba(15, 15, 15, 0.94), rgba(30, 30, 30, 0.95))",
        "--body-grad": "radial-gradient(circle at 12% 9%, #252525 0%, #101010 42%, #050505 100%)"
      }
    }
  };

  const ROLE_MAP = {
    currentTheme: '[data-role="current-theme"]',
    heroPill: '[data-role="hero-pill"]',
    heroKicker: '[data-role="hero-kicker"]',
    heroTitle: '[data-role="hero-title"]',
    heroCopy: '[data-role="hero-copy"]',
    stat1Label: '[data-role="stat-1-label"]',
    stat1Value: '[data-role="stat-1-value"]',
    stat2Label: '[data-role="stat-2-label"]',
    stat2Value: '[data-role="stat-2-value"]',
    stat3Label: '[data-role="stat-3-label"]',
    stat3Value: '[data-role="stat-3-value"]'
  };

  const GLOBAL_THEME_MAP = {
    "race-track": "raceTrack",
    "off-road-trail": "offRoadTrail",
    "long-distance-cruise": "longDistanceCruise",
    "geek-diagnostic": "geekDiagnostic",
    "cyber-night-ride": "cyberNightRide",
    "minimal-light": "minimalLight",
    "minimal-dark": "minimalDark"
  };

  function resolveElements(root) {
    return Object.keys(ROLE_MAP).reduce((acc, key) => {
      acc[key] = root.querySelector(ROLE_MAP[key]);
      return acc;
    }, {});
  }

  function setText(element, value) {
    if (element && typeof value === "string") {
      element.textContent = value;
    }
  }

  function syncGlobalTheme(themeId) {
    const globalTheme = GLOBAL_THEME_MAP[themeId];
    if (!globalTheme) return;

    document.documentElement.setAttribute("data-app-theme", globalTheme);
    document.documentElement.style.colorScheme = globalTheme === "minimalLight" ? "light" : "dark";

    try {
      window.localStorage.setItem("appTheme", globalTheme);
      window.localStorage.setItem("begode_theme", globalTheme);
    } catch (error) {
      // Ignore storage failures so the preview still works.
    }
  }

  function applyTheme(root, themeId, elements) {
    const selected = THEMES[themeId];
    if (!selected) return;

    Object.entries(selected.vars).forEach(([token, value]) => {
      root.style.setProperty(token, value);
    });

    setText(elements.currentTheme, selected.name);
    setText(elements.heroPill, selected.heroPill);
    setText(elements.heroKicker, selected.heroKicker);
    setText(elements.heroTitle, selected.heroTitle);
    setText(elements.heroCopy, selected.heroCopy);
    setText(elements.stat1Label, selected.stats[0].label);
    setText(elements.stat1Value, selected.stats[0].value);
    setText(elements.stat2Label, selected.stats[1].label);
    setText(elements.stat2Value, selected.stats[1].value);
    setText(elements.stat3Label, selected.stats[2].label);
    setText(elements.stat3Value, selected.stats[2].value);

    const heroImage = root.querySelector('.btl-hero-image');
    const allowThemeHeroImage = root.dataset.allowThemeHeroImage === 'true';
    if (heroImage && allowThemeHeroImage && selected.heroImage) {
      heroImage.src = selected.heroImage;
    }

    root.querySelectorAll('.btl-theme-option').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.theme === themeId);
    });

    syncGlobalTheme(themeId);
  }

  function init(root) {
    if (!root || root.dataset.btlInited === '1') return;
    root.dataset.btlInited = '1';

    const elements = resolveElements(root);
    const defaultTheme = root.dataset.defaultTheme || 'cyber-night-ride';

    root.querySelectorAll('.btl-theme-option').forEach((button) => {
      button.addEventListener('click', () => {
        applyTheme(root, button.dataset.theme, elements);
      });
    });

    applyTheme(root, defaultTheme, elements);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.begode-theme-lab').forEach(init);
  });
})();
